import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=718a0a70&"
import script from "./_id.vue?vue&type=script&lang=ts&"
export * from "./_id.vue?vue&type=script&lang=ts&"
import style0 from "./_id.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports